module.exports = __webpack_public_path__ + "static/media/service_system_2.e367de61.png";